export default "__VITE_ASSET__69a4a98f__"